import React from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-206">
      <Header data-id="element-207" />
      <main className="flex-grow" data-id="element-208">{children}</main>
      <Footer data-id="element-209" />
    </div>;
}